<template>
  <div>
    <b-form @submit.prevent="validForm">
      <b-tabs>
        <b-tab title="Dados Cadastrais" v-if="usuario.tipo !== 'atendente'">
          <div class="row">
            <div class="col">
              <b-form-group label="Credenciado" label-for="exampleInput1">
                <b-form-input
                  :state="
                    $v.conveniado.$error ? !$v.conveniado.loja.$error : null
                  "
                  v-model="conveniado.loja"
                  class="edit-input"
                  type="text"
                  placeholder="Nome"
                />
              </b-form-group>
            </div>
            <div class="col">
              <b-form-group label="CRM/Registro">
                <b-form-input v-model="conveniado.registro"> </b-form-input>
              </b-form-group>
            </div>
            <div class="col">
              <b-form-group label="Cadastro">
                <b-form-datepicker
                  disabled
                  v-model="conveniado.cadastro"
                  format="DD/MM/YYYY"
                  valueType="YYYY-MM-DD"
                  :date-format-options="{
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric',
                  }"
                  locale="pt-br"
                >
                  <template v-slot:button-content>
                    <b-icon icon="calendar" variant="primary"></b-icon>
                  </template>
                </b-form-datepicker>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <b-form-group label="Nome">
                <b-form-input
                  :state="
                    $v.conveniado.$error ? !$v.conveniado.nome.$error : null
                  "
                  v-model="conveniado.nome"
                  class="edit-input"
                  type="text"
                >
                </b-form-input>
              </b-form-group>
            </div>
            <div class="col">
              <b-form-group label="Email">
                <b-form-input
                  :state="
                    $v.conveniado.$error ? !$v.conveniado.email.$error : null
                  "
                  v-model="conveniado.email"
                  class="edit-input"
                  type="email"
                >
                </b-form-input>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <b-form-group label="Grupo">
                <b-form-select
                  :state="
                    $v.conveniado.$error ? !$v.conveniado.grupo.$error : null
                  "
                  v-model="conveniado.grupo"
                  :options="grupos"
                >
                </b-form-select>
              </b-form-group>
            </div>
            <div class="col">
              <b-form-group label="Especialidade">
                <b-form-select
                  :state="
                    $v.conveniado.$error
                      ? !$v.conveniado.especialidade.$error
                      : null
                  "
                  v-model="conveniado.especialidade"
                  :options="especialidades"
                >
                </b-form-select>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <b-form-group label="Local">
                <b-form-input
                  :state="
                    $v.conveniado.$error ? !$v.conveniado.local.$error : null
                  "
                  v-model="conveniado.local"
                >
                </b-form-input>
              </b-form-group>
            </div>
            <div class="col">
              <b-form-group label="Telefone">
                <b-form-input
                  :state="
                    $v.conveniado.$error ? !$v.conveniado.telefone.$error : null
                  "
                  v-model="conveniado.telefone"
                  v-mask="
                    conveniado.telefone
                      ? conveniado.telefone.length <= 14
                        ? '(##) ####-####'
                        : '(##) # ####-####'
                      : '(##) ####-####'
                  "
                ></b-form-input>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <b-form-group label="Não marcar pré-agenda">
                <b-form-checkbox
                  :value="true"
                  :unchecked-value="false"
                  v-model="conveniado.not_generate_preschedule"
                >
                </b-form-checkbox>
              </b-form-group>
            </div>
            <div class="col">
              <b-form-group label="Inativo">
                <b-form-checkbox
                  :value="true"
                  :unchecked-value="false"
                  v-model="conveniado.inativo"
                >
                </b-form-checkbox>
              </b-form-group>
            </div>
          </div>
        </b-tab>
        <!-- <b-tab title="Endereço e Contato"> </b-tab> -->
        <b-tab title="Atendimentos" v-if="usuario.tipo !== 'atendente'">
          <div class="row">
            <div class="col">
              <b-form-group label="Limite Atendimentos">
                <b-form-input v-model="conveniado.limiteAtendimentos">
                </b-form-input>
              </b-form-group>
            </div>
            <div class="col">
              <b-form-group label="Prazo Retorno">
                <b-form-input v-model="conveniado.prazoRetorno" type="number">
                </b-form-input>
              </b-form-group>
            </div>
          </div>
          <b-form-fieldset
            v-for="(unidade, index) of unidades"
            :key="unidade.id"
            :label="'Unidade ' + unidade.unidade"
          >
            <div class="row">
              <div class="col">
                <b-form-group label="Limite Consulta">
                  <b-form-input
                    type="number"
                    v-model="conveniado.limite[index].limite_consulta"
                  >
                  </b-form-input>
                </b-form-group>
              </div>
              <div class="col">
                <b-form-group label="Limite Retorno">
                  <b-form-input
                    type="number"
                    v-model="conveniado.limite[index].limite_retorno"
                  >
                  </b-form-input>
                </b-form-group>
              </div>
            </div>
          </b-form-fieldset>
          <!-- <div class="row">
            <div class="col">
              <b-form-group label="Orçamento Geral">
                <b-form-input
                  v-model="conveniado.orcamentoGeral"> </b-form-input>
              </b-form-group>
            </div>
            <div class="col">
              <b-form-group label="Orçamento Labotarório">
                <b-form-input
                  v-model="conveniado.orcamentoLab"> </b-form-input>
              </b-form-group>
            </div>
          </div> -->
        </b-tab>
        <b-tab
          title="Procedimentos"
          :disabled="conveniado._id ? false : true"
          v-if="usuario.tipo !== 'atendente'"
        >
          <template v-if="conveniado._id">
            <div class="row">
              <div class="col-8">
                <b-form-group label="Conveniado">
                  <b-form-input v-model="conveniado.nome" disabled>
                  </b-form-input>
                </b-form-group>
              </div>
              <div class="col-4">
                <b-form-group label="Grupo">
                  <b-form-select
                    :state="
                      $v.conveniado.$error ? !$v.conveniado.grupo.$error : null
                    "
                    v-model="conveniado.grupo"
                    :options="grupos"
                  >
                  </b-form-select>
                </b-form-group>
              </div>
            </div>
            <div
              class="row"
              v-if="conveniado.tabelaPreco.length && procedimentos.length"
            >
              <div class="col-8">
                <b-form-group label="Procedimento">
                  <b-form-input
                    @focus="showProcedureFilter = true"
                    name="filterProcedure "
                    v-model="formProcedure"
                  ></b-form-input>
                  
                  <div class="filtered-select" v-if="showProcedureFilter">
                    <ul>
                      <li
                        v-for="procedure of filteredProcedures"
                        :key="procedure._id"
                        @click="selectProcedure(procedure)"
                        >{{ procedure.descricao }}</li
                      >
                    </ul>
                  </div>

                </b-form-group>
              </div>

              <div class="col-4" v-if="conveniado.tabelaPreco[
                    getProcedureIndexById(procedimentoSelected)
                  ]">
                <b-form-group label="Custo Real">
                  <b-input-group prepend="R$">
                    <b-form-input v-model="conveniado.tabelaPreco[
                          getProcedureIndexById(procedimentoSelected)
                        ].custoProcedimento"></b-form-input>
                  </b-input-group>
                </b-form-group>

                <div class="col" v-for="(plano, index) of planos" :key="plano._id">
                  <b-form-group 
                    v-if="conveniado.tabelaPreco[
                        getProcedureIndexById(procedimentoSelected)
                      ].precoPorPlano[index]"
                    id="fieldset-horizontal"
                    label-cols-sm="3"
                    label-cols-lg="5"
                    content-cols-sm
                    content-cols-lg="7"
                    :label="plano.descricao"
                    label-for="input-horizontal"
                  >
                    <b-input-group prepend="R$">
                      <b-form-input v-model="conveniado.tabelaPreco[
                            getProcedureIndexById(procedimentoSelected)
                          ].precoPorPlano[index].preco" id="input-horizontal">
                      </b-form-input>
                    </b-input-group>
                  </b-form-group>
                </div>

              </div>
            </div>
            
            <div v-else class="row">
              <div class="col-8">
                <b-form-group label="Procedimento">
                  <b-form-select v-model="procedimentoSelected">
                    <b-form-select-option value="" disabled>
                      Não há Procedimentos ligados a esse Grupo.
                    </b-form-select-option>
                  </b-form-select>
                </b-form-group>
              </div>
            </div>

          </template>
        </b-tab>

        <b-tab title="Dados Financeiros" v-if="usuario.tipo !== 'atendente'">
          <div class="row">
            <div class="col-4">
              <b-form-group label="Banco">
                <b-form-select
                  v-model="conveniado.banco"
                  :options="bancos"
                ></b-form-select>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-4">
              <b-form-group label="Agencia">
                <b-form-input
                  v-model="conveniado.agencia"
                  v-mask="'####-#'"
                ></b-form-input>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-4">
              <b-form-group label="Conta Corrente">
                <b-form-input v-model="conveniado.contaCorrente"></b-form-input>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-4">
              <b-form-group label="Chave PIX">
                <b-form-input v-model="conveniado.chavePix"></b-form-input>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-4">
              <b-form-group label="Formas de Pagamentos">
                <b-form-select
                  v-model="conveniado.formaPagamento"
                  :options="formadPagamento"
                ></b-form-select>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-4">
              <b-form-group label="Observações">
                <b-textarea v-model="conveniado.financeiroObs"></b-textarea>
              </b-form-group>
            </div>
          </div>
        </b-tab>
        <b-tab
          title="Agenda"
          :disabled="
            (conveniado._id ? false : true) ||
            conveniado.not_generate_preschedule
          "
        >
          <div class="row">
            <div class="col-4">
              <b-form-group label="Montagem">
                <div class="row">
                  <div class="col">
                    <b-form-group label="Bloco">
                      <b-form-input
                        v-for="index of 7"
                        :key="index"
                        v-model="montagem[index - 1].bloco"
                      ></b-form-input>
                    </b-form-group>
                  </div>
                  <div class="col">
                    <b-form-group label="Quantidade">
                      <b-form-input
                        v-for="index of 6"
                        :key="index"
                        v-model="montagem[index - 1].quantidade"
                        type="number"
                      ></b-form-input>
                    </b-form-group>
                  </div>
                  <div class="col">
                    <b-form-group label="Hora">
                      <b-form-input
                        v-for="index of 6"
                        :key="index"
                        v-mask="
                          montagem[index - 1]
                            ? montagem[index - 1].length <= 4
                              ? '#:##'
                              : '##:##'
                            : '#:##'
                        "
                        v-model="montagem[index - 1].horario"
                      ></b-form-input>
                    </b-form-group>
                  </div>
                </div>
              </b-form-group>
            </div>
            <div class="col-4">
              <b-form-group label="Pré-visualização">
                <div class="row">
                  <div class="col">
                    <b-form-group label="Bloco">
                      <b-form-input
                        v-for="index of previewAgendamentos"
                        :key="index"
                        disabled
                        v-model="index.bloco"
                      ></b-form-input>
                    </b-form-group>
                  </div>
                  <div class="col">
                    <b-form-group label="Hora">
                      <b-form-input
                        v-for="index of previewAgendamentos"
                        :key="index"
                        disabled
                        v-model="index.horario"
                      ></b-form-input>
                    </b-form-group>
                  </div>
                </div>
              </b-form-group>
            </div>
            <div class="col-4">
              <b-form-group label="Datas">
                <div class="row">
                  <div class="col">
                    <div v-for="index of 6" :key="index" class="row">
                      <b-form-datepicker
                        class="col"
                        :date-format-options="{
                          year: 'numeric',
                          month: 'numeric',
                          day: 'numeric',
                        }"
                        :class="{
                          'is-invalid': errorDates.includes(
                            agendaDatas[index - 1]
                          ),
                        }"
                        v-model="agendaDatas[index - 1]"
                        :min="new Date()"
                        locale="pt-Br"
                      >
                        <template v-slot:button-content>
                          <b-icon icon="calendar" variant="primary"></b-icon>
                        </template>
                      </b-form-datepicker>
                    </div>
                  </div>
                </div>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-4">
              <b-button variant="info" @click="gerarAgenda"
                >Gerar agenda</b-button
              >
            </div>
            <div class="col-4">
              <b-button variant="warning" @click="modalAlterar"
                >Alterar agenda</b-button
              >
            </div>
            <div>
              <b-button variant="info" @click="limparTabela"
                >Apagar blocos</b-button
              >
            </div>
          </div>
          <br />
        </b-tab>
        <b-tab title="Documentos" v-if="conveniado._id">
          <div class="row documentos-row">
            <div class="col-3 row">
              <input class="col-8" @change="previewFile" type="file" placeholder="" />
              <b-button class="col-4" @click="uploadFiles">Adicionar Documento</b-button>
              <b-input class="col-12" v-model="fileName" placeholder="nome do arquivo"></b-input>
            </div>
          </div>
          <div class="row documentos-row">
            <div class="col-3 image_wrapper" v-for="(documento, index) of conveniado.documentos" :key="index">
              <h5 for="">{{ documento.name }}</h5>
              <img v-if="fileType(documento.extension)==='image'" class="col-12" :src="documento.url" :alt="documento.name">
              <img v-else-if="fileType(documento.extension)==='pdf'" src="@assets/images/Icon PDF - Ícone.png" class="col-12"/>
              <img v-else-if="fileType(documento.extension)==='doc'" src="@assets/images/doc-icon.png" class="col-12"/>
              <img v-else-if="fileType(documento.extension)==='excel'" src="@assets/images/microsoft-excel-icon.png" class="col-12"/>
              <img v-else src="@assets/images/Generic File Icon.png" class="col-12"/>
              <div class="overlay">
                
                <a target="blank" :href="documento.url"><b-icon icon="download" class="h1" variant="dark"></b-icon></a>
                <h1 @click="removeFile(index)" >X</h1>
                
              </div>
              
              
            </div>
          </div>
        </b-tab>
      </b-tabs>

      <b-button type="submit" variant="primary">Salvar</b-button>
    </b-form>

    <b-modal id="alterar-modal" centered title="Alterar Agenda" hide-footer>
      <div class="d-flex flex-column">
        <b-form-group label="Ação">
          <b-form-select
            v-model="change.action"
            :options="changeActions"
          ></b-form-select>
        </b-form-group>
        <b-form-group label="Selecionada">
          <b-form-datepicker
            :date-format-options="{
              year: 'numeric',
              month: 'numeric',
              day: 'numeric',
            }"
            v-model="change.selected"
            locale="pt-Br"
          >
            <template v-slot:button-content>
              <b-icon icon="calendar" variant="primary"></b-icon>
            </template>
          </b-form-datepicker>
        </b-form-group>
        <b-form-group label="Nova Data" v-if="change.action === 'alterar'">
          <b-form-datepicker
            :date-format-options="{
              year: 'numeric',
              month: 'numeric',
              day: 'numeric',
            }"
            v-model="change.newDate"
            locale="pt-Br"
          >
            <template v-slot:button-content>
              <b-icon icon="calendar" variant="primary"></b-icon>
            </template>
          </b-form-datepicker>
        </b-form-group>
        <b-button variant="primary" @click="executeChange">Executar</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import EspecialidadeService from '@/src/services/especialidade'
import GrupoService from '@/src/services/grupo'

import unidadeMixin from '@/src/mixins/unidadeMixin'
import procedimentosMixin from '@/src/mixins/procedimentosMixin'
import planosMixin from '@/src/mixins/planosMixin'
import agendaMedicaMixin from '@/src/mixins/agendaMedicaMixin'
import { required, email } from 'vuelidate/lib/validators'
import alertMixin from '@/src/mixins/alertMixin'

export default {
  props: [
    'conveniado',
    'onSubmit',
    'onEdit',
    'onChangeFile',
    'tabelaPreco',
    'executeChange',
    'change',
  ],
  mixins: [
    unidadeMixin,
    procedimentosMixin,
    planosMixin,
    agendaMedicaMixin,
    alertMixin,
  ],
  data() {
    return {
      especialidades: [],
      grupos: [],
      unidades: [],
      planos: [],
      procedimentos: [],
      procedimentosAlterados: [],
      procedimentosFields: [{ key: 'descricao', label: 'Procedimento' }],
      procedimentoSelected: 0,
      changeActions: [
        { value: 'alterar', text: 'Alterar' },
        { value: 'cancelar', text: 'Cancelar' },
        { value: 'bloquear', text: 'Bloquear' },
      ],
      formadPagamento: [
        { value: 'antecipado_em_maos', text: 'Antecipado me mãos' },
        { value: 'deposito_antecipado', text: 'Depósito Antecipado' },
        { value: 'deposito_mensal', text: 'Depósito Mensal' },
        { value: 'deposito_semanal', text: 'Depósito Semanal' },
        { value: 'mensal_bdi', text: 'Mensal BDI' },
        { value: 'mensal_faturamento', text: 'Mensal Faturamento' },
        { value: 'pos_atendiemnto', text: 'Pós-atendiemnto' },
      ],
      bancos: [
        { value: '001', text: '001 - Banco do Brasil' },
        { value: '004', text: '004 - Banco do Nordeste' },
        { value: '033', text: '033 - Banco Santander' },
        { value: '077', text: '077 - Banco Inter' },
        { value: '104', text: '104 - Caixa Economica Federal' },
        { value: '237', text: '237 - Banco Bradesco' },
        { value: '260', text: '260 - Nubank' },
        { value: '290', text: '290 - PagSeguro' },
        { value: '341', text: '341 - Banco Itau' },
        { value: '756', text: '756 - Bancoob - Banco Cooperativa do Brasil' },
      ],
      montagem: [{}, {}, {}, {}, {}, {}, {}],
      previewAgendamentos: [],
      agendamentos: [],
      agendaDatas: [],
      usuario: this.$store.state.auth.currentUser.usuario,
      errorDates: [],
      filteredProcedures: [],
      checkLimit: {},
      monthDays: 0,
      formProcedure: '',
      fileName: '',
      showProcedureFilter: false,
      formDataFile: new FormData()
    }
  },
  // // computed: {
  // //   tabelaPrecoGen() {
  // //     return
  // //   },
  // },
  validations: {
    conveniado: {
      loja: { required },
      nome: { required },
      email: { email },
      grupo: { required },
      especialidade: { required },
      local: { required },
      telefone: { required },
    },
  },
  watch: { 
    'conveniado.grupo'() {
      this.loadProcedimentosFunc()
    },
    'conveniado.limite': {
      handler: function (newValue) {
        let limite = 0
        for (let index = 0; index < this.conveniado.limite.length; index++) {
          limite += parseInt(this.conveniado.limite[index].limite_consulta)
          limite += parseInt(this.conveniado.limite[index].limite_retorno)
          if (index >= this.conveniado.limite.length - 1)
            this.conveniado.limiteAtendimentos = limite
        }
      },
      deep: true,
    },
    'conveniado.tabelaPreco': {
      handler: function (newValue) {
        this.addItemAlterado(this.procedimentoSelected)
      },
      deep: true,
    },
    formProcedure() {
      this.filterProcedure(this.formProcedure)
      this.showProcedureFilter = true
    },
  },
  computed: {
    getEspecialidade() {
      return this.conveniado.especialidade
        ? this.conveniado.especialidade.descricao
        : ''
    },
  },
  mounted() {
    this.loadAllFields()
    this.validaCampos()
  },
  methods: {
    fileType(extension){
      if(["jpg","png", "gif", "webp", "tiff", "psd", "raw", "bmp", "heif", "indd", "jpeg", "svg", "ai", "eps"]
      .includes(extension.toLowerCase()))
        return "image"
      else if(extension.toLowerCase()==="pdf")
        return "pdf"
      else if(["doc","docx"].includes(extension.toLowerCase()))
        return "doc"
      else if(["xlsx", "xlsm", "xlsb", "xltx", "xltm", "xls", "xlt", "xls", "xml", "xml", "xml", "xlam", "xla", "xlw", "Xlr"].includes(extension.toLowerCase()))
        return "excel"
      else
        return "other"
    },
    removeFile(index){
      this.conveniado.documentos.splice(index,1)
    },
    previewFile(e){
      if(e.target.files[0]){
        this.fileName = e.target.files[0].name
        this.formDataFile.append("file", e.target.files[0]);
      }
    },
    async uploadFiles() {
      await this.onChangeFile({formData:this.formDataFile, fileName:this.fileName})
      this.formDataFile = new FormData()
    },
    async selectProcedure(procedure) {
      this.formProcedure = procedure.descricao
      this.procedimentoSelected = procedure._id
      
      setTimeout(() => {
        this.showProcedureFilter = false
       
      }, 100)
    },
    filterProcedure(filter) {
      if (!filter) {
        this.filteredProcedures = this.procedimentos.slice(0, 500)
        return
      }
      this.filteredProcedures = this.procedimentos
        .filter((i) => {
          return (
            i.descricao
              ? i.descricao.toLowerCase().includes(filter.toLowerCase())
              : false
          )
        })
        .slice(0, 15)
    },
    modalAlterar() {
      this.$bvModal.show('alterar-modal')
    },
    async gerarAgenda() {
      let montagem = this.montagem.filter((i) => !!i.bloco)
      let agendamentos = this.getAgedamentoList(montagem)
      const checkLimit = await this.findLimitPerDay({
        conveniado: this.conveniado._id,
        days: this.agendaDatas,
        quantity: agendamentos.length,
      })
      this.errorDates = []
      for (let check of checkLimit.data) {
        if (check.count > this.conveniado.limiteAtendimentos || check.blocked) {
          this.errorDates.push(check.day)
        }
      }

      if (this.errorDates.length) {
        this.errorMessage('Limite excedido em uma ou mais datas')
        return
      }

      for (let index = 0; index < this.agendaDatas.length; index++) {
        this.agendamentos = this.agendamentos.concat(
          agendamentos.map((item) => {
            return { ...item, dataHora: this.agendaDatas[index] }
          })
        )
        if (index === this.agendaDatas.length - 1) {
          await this.handlecreate()
          this.previewAgendamentos = agendamentos
        }
      }
    },
    async handlecreate() {
      return await this.registerManyAgendaMedica(this.agendamentos)
    },
    limparTabela() {
      this.agendamentos = []
      this.previewAgendamentos = []
      this.montagem = [{}, {}, {}, {}, {}, {}, {}]
    },
    getAgedamentoList(montagens) {
      let count = 0
      let agendamentos = []
      for (let item of montagens) {
        const { quantidade, ...montagem } = item
        montagem.conveniado = this.conveniado._id
        montagem.unidade = this.conveniado.local
        agendamentos = agendamentos.concat(
          Array(parseInt(quantidade)).fill(montagem)
        )
        count++
        if (count >= montagens.length) return agendamentos
      }
    },
    getProcedureIndexById(id) {
      return id ? this.conveniado.tabelaPreco.findIndex((i) => i.procedimento ? i.procedimento._id == id : 0) : 0
    },
    loadEspecialidades() {
      this.especialidades = []
      EspecialidadeService.list().then((resposta) => {
        resposta.data.map((item) => {
          this.especialidades.push({
            value: item._doc,
            text: item._doc.descricao,
          })
        })
      })
    },
    loadGrupos() {
      this.grupos = []
      GrupoService.list().then((resposta) => {
        resposta.data.map((item) => {
          this.grupos.push({
            value: item._doc,
            text: item._doc.grupo,
          })
        })
      })
    },
    loadAgenda() {
      for (let index = 0; index < 12; index++) {
        this.montagem[index] = {}
      }
    },
    async loadAllFields() {
      await this.loadEspecialidades()
      await this.loadGrupos()
      await this.loadPlanos().then((planos) => {
        this.planos = planos
      })

      if (!this.conveniado._id) {
        await this.loadUnidades().then((unidades) => {
          this.unidades = unidades
          unidades.map((unidade) => {
            this.conveniado.limite.push({
              unidade: unidade.unidade,
              limite_consulta: 0,
              limite_retorno: 0,
            })
          })
        })
      } else {
        this.unidades = this.conveniado.limite
      }
      var v = this

      setTimeout(function () {
        v.loadProcedimentosFunc()
      }, 1000)
    },

    async loadProcedimentosFunc() {
      await this.loadProcedimentos().then((procedimentos) => {
        procedimentos.map((p) => {
          if (p.grupo)
            if (p.grupo._id === this.conveniado.grupo._id) {
              this.procedimentos.push(p)
            }
        })
        this.procedimentos.map((procedimento) => {
          let precoPorPlano = this.planos.map((plano) => {
            return {
              plano: plano,
              preco: 0,
            }
          })
          let tabelaIndex = this.conveniado.tabelaPreco.findIndex((i) =>
            i.procedimento ? i.procedimento._id === procedimento._id : false
          )

          if (tabelaIndex >= 0) {
            let thisPrecoPorPlano =
              this.conveniado.tabelaPreco[tabelaIndex].precoPorPlano
            precoPorPlano.map((preco) => {
              if (
                thisPrecoPorPlano.findIndex((i) =>
                  i.plano ? i.plano._id === preco.plano._id : false
                ) < 0
              )
                thisPrecoPorPlano.push(preco)
            })
            this.conveniado.tabelaPreco[tabelaIndex].precoPorPlano =
              thisPrecoPorPlano
          } else
            this.conveniado.tabelaPreco.push({
              procedimento: procedimento,
              custoProcedimento: 0,
              precoPorPlano: precoPorPlano,
            })
        })
        this.selectProcedure(this.procedimentos[0])
        this.procedimentoSelected = this.procedimentos[0]
          ? this.procedimentos[0]._id
          : 0
      })
    },

    validaCampos() {
      if (!this.conveniado._id) {
        this.conveniado.cadastro = new Date()
      }
    },
    invalidForm() {
      this.$bvToast.toast('Há campos que não foram preenchidos', {
        variant: 'danger',
        solid: false,
        noCloseButton: true,
        toaster: 'b-toaster-top-center',
      })
    },
    addItemAlterado(id) {
      if (!this.procedimentosAlterados.includes(id)) {
        this.procedimentosAlterados.push(id)
        this.tabelaPreco.push(
          this.conveniado.tabelaPreco[this.getProcedureIndexById(id)]
        )
      }
    },
    validForm() {
      this.$v.$touch()
      !this.$v.conveniado.$error
        ? this.conveniado._id
          ? this.onEdit()
          : this.onSubmit()
        : this.invalidForm()
    },
  },
}
</script>

<style scoped>
.image_wrapper{
  position: relative;
}
.image_wrapper h5{
  margin-left: 10px;
}
.overlay h1{
  cursor: pointer;
  color: rgb(117, 3, 3);
}
.overlay h1:hover{
  color: red;
}
.overlay a:hover{
  color: white;
}
.overlay a{
  margin-right: 25px;
}
.overlay:hover{
  background: rgba(57, 57, 57, 0.9);
}
.overlay {
  position: absolute; 
  background: rgba(57, 57, 57, 0.1);

  /* center overlay text */
  display: flex;
  align-items: center;
  justify-content: center;
  left: 0;
  bottom: 0;
  width: 100%;
  padding: 1rem;
}
.documentos-row{
  margin-bottom: 20px;
}
.filtered-select {
  position: absolute;
  background-color: white;
  width: 96%;
  left: 0;
  z-index: 100;
}
.filtered-select ul {
  list-style: none;
  padding-left: 19px;
}
.filtered-select ul li {
  padding-top: 10px;
  padding-left: 10px;
  font-size: 14px;
  border-radius: 2%;
  justify-content: center;
}
.filtered-select ul li:hover {
  background-color: #0088a8;
  color: white;
  transition: 200ms;
}
.absolute {
  position: absolute;
  z-index: 100;
}
</style>
